//helper function to slow down functions from being called to many times
function debounce(func, wait = 2000, immediate = true) {
  var timeout;
  return function() {
    var context = this,
      args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func;
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func;
  };
}
/* function debounce(fn) {
  var timeout;
  return function() {
    console.log(hello)
    if (timeout == null) {
      fn();
      timeout = setTimeout(() => (timeout = null), 200);
    } else {
      return;
    }
  };
} */
export { debounce };
